import React from 'react';
import { Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Stack } from '@mui/material';
import type { ItemMasterEntryView } from '../../../claims';

interface ItemMasterEntryDetailDialogProps {
  open: boolean;
  onClose: () => void;
  entry: ItemMasterEntryView;
}

const formatCurrency = (amount: number) => new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
}).format(amount);

const toLocalDateTime = (isoUtc: string) => new Date(isoUtc).toLocaleString().replace(',', '');

/**
 * Read-only item-master entry detail dialog (CAM-C10 US3). Chrome copied from `EditRoomDialog` —
 * every field disabled, Close-only action, no save.
 */
export const ItemMasterEntryDetailDialog: React.FC<ItemMasterEntryDetailDialogProps> = ({ open, onClose, entry }) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle>Item Master Entry</DialogTitle>
    <DialogContent>
      <Stack spacing={0}>
        <TextField margin="dense" label="Item #" fullWidth value={entry.itemNum} disabled />
        <TextField margin="dense" label="Description" fullWidth value={entry.itemDesc} disabled />
        <TextField margin="dense" label="CPT" fullWidth value={entry.cpt} disabled />
        <TextField margin="dense" label="OP Charge Amt" fullWidth value={formatCurrency(entry.opChargeAmt)} disabled />
        <TextField margin="dense" label="IP Charge Amt" fullWidth value={formatCurrency(entry.ipChargeAmt)} disabled />
        <TextField margin="dense" label="Unit Cost" fullWidth value={formatCurrency(entry.unitCost)} disabled />
        <TextField margin="dense" label="Mfg Cat Num" fullWidth value={entry.manufacturerCatNum ?? ''} disabled />
        <TextField margin="dense" label="Rev Code" fullWidth value={entry.revCode ?? ''} disabled />
        <TextField margin="dense" label="Status" fullWidth value={entry.active ? 'Active' : 'Inactive'} disabled />
        <TextField margin="dense" label="Last Modified" fullWidth value={toLocalDateTime(entry.lastModified)} disabled />
        <TextField margin="dense" label="Ingested At" fullWidth value={toLocalDateTime(entry.ingestedAtUtc)} disabled />
      </Stack>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Close</Button>
    </DialogActions>
  </Dialog>
);
